document.addEventListener("DOMContentLoaded", function () {

  // cart sidebar js start--
document.querySelectorAll(".cart-sidebar-toggle-btn").forEach(function(btn) {
  btn.addEventListener("click", function(event) {
     event.preventDefault();
     const cartSidebar = document.querySelector(".cart-sidebar");
    if (cartSidebar) cartSidebar.classList.toggle("active");

    //
    // localStorage.setItem("toggleCartSidebarAfterReload", "true");
    // location.reload();
  });
});

// window.addEventListener("load", function() {
//   console.log("toggleCartSidebarAfterReload" + localStorage.getItem("toggleCartSidebarAfterReload"));
//   if (localStorage.getItem("toggleCartSidebarAfterReload") === "true") {
//     const overlay = document.querySelector('.overlayussge');
//     if (overlay) overlay.style.display = 'block';

//     const cartSidebar = document.querySelector(".cart-sidebar");
//     if (cartSidebar) cartSidebar.classList.toggle("active");

//     document.body.classList.toggle("active");

//     localStorage.removeItem("toggleCartSidebarAfterReload");
//   }
// });

  document.querySelectorAll(".testimonial-card-text").forEach(el => {
    const fullText = el.getAttribute("data-full").trim();
    const wordLimit = parseInt(el.getAttribute("data-words"), 10) || 50;
    const readMoreBtn = el.querySelector(".read-more-btn");
    const readLessBtn = el.querySelector(".read-less-btn");

    // function to truncate to X words
    const truncateWords = (text, limit) => {
      const words = text.split(/\s+/);
      return words.slice(0, limit).join(" ") + (words.length > limit ? "..." : "");
    };

    if (readMoreBtn && readLessBtn) {
      readMoreBtn.addEventListener("click", () => {
        el.firstChild.textContent = fullText + " ";
        readMoreBtn.style.display = "none";
        readLessBtn.style.display = "inline";
      });

      readLessBtn.addEventListener("click", () => {
        el.firstChild.textContent = truncateWords(fullText, wordLimit) + " ";
        readMoreBtn.style.display = "inline";
        readLessBtn.style.display = "none";
      });
    }
  });
});





$(document).ready(function () {
  "use strict";

  
  //..navbar menu js start..//
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar-wrapper-main").addClass("nav-fixed");
    } else {
      $(".navbar-wrapper-main").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".mobile-menu-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".ham-menu-text").toggleClass("active");
  });

  $(".mobile-menu-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".mobile-menu-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".ham-menu-text").toggleClass("active");
  });

  // $(".mobile-drop-down-menu").on("click", function () {
  //   $(this).children(".mobile-drop-down-menu-wrapper").slideToggle();
  //   $(this).children(".drop-down-menu-btn").toggleClass("active");
  // });
  //..navbar mobile-menu js end..//

  // **..accordion js start..**
  // $(".faq-accordion-item-content").slideUp();
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..accordion js end..**

  // **..tab-accordion js start..**
  // $(".tab-accordion-content").slideUp();
  $(".tab-accordion-btn-wrap").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..tab-accordion js end..**

  // --tab js start--
  $(".tab-nav-item:first-child").addClass("active");
  $(".desktop-tab-content-item").hide();
  $(".desktop-tab-content-item:first").show();

  $(".desktop-tabs-nav-item-link").click(function () {
    $(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".desktop-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  // mobile-tab js----
  $(".mobile-tab-nav-item:first-child").addClass("active");
  $(".mobile-tab-content-item").hide();
  $(".mobile-tab-content-item:first").show();

  $(".mobile-tabs-nav-item-link").click(function () {
    $(".mobile-tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".mobile-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --tab js end--

  // back-to-top js start--
  $(".back-to-top").on("click", function (e) {
    e.preventDefault();
    $("html,body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });
  // color select
  $(".color_select").on("change", function (e) {
    var color = $(this).val();
    $(".selected_color").text(color);
  });
  // back-to-top js end--

  // filter sidebar js start--

  // $('.filter-accordion-toggle-btn').on('click', function () {
  // 	$(this).next().slideToggle();
  // 	$(this).parent().toggleClass('active');
  // 	// $(this).parent().siblings().removeClass('active').find('.filter-accordion-item-content').slideUp();
  // });

  $(".filter-open-btn").click(function (event) {
    event.preventDefault();
    $(".categories-page-filter-area").toggleClass("active");
  });

  $(".filter-close-window-btn").click(function (event) {
    event.preventDefault();
    $(".categories-page-filter-area").removeClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.preventDefault();
    $(".categories-page-filter-area").toggleClass("active");
  });

  $(".mirror_input").on("change", function () {
    var txt = $(this).val();
    $("#mirror_heading em").text(txt);
  });
  $(".custom_color_input").on("keyup", function () {
    var txt = $(this).val();
    $(".selected_color").text(txt);
  });

  $(".design_input").on("change", function () {
    var txt = $(this).val();
    let parent = $(this).closest(".product-color-tab-content-item"); // Adjust as needed
    parent.find(".design_heading em").text(txt);
    let src = $(this).next().find("img").attr("src");
    parent.find(".design_img").attr("src", src).attr("srcset", src);
  });

  $(".search_icon").on("click", function () {
    $(".nav-info-search-wrap").toggleClass("active");
  });

  // $(".tab-accordion-btn-wrap").click(function (event) {
  // 	event.preventDefault();
  // 	$(this).next().slideToggle();
  // });
});

// cart slider js start--
var swiper = new Swiper(".cart-product-slider", {
  slidesPerView: 2.5,
  spaceBetween: 20,
  grabCursor: true,
  loop: true,
  pagination: {
    el: ".cart-slider-pagination",
    clickable: true,
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      slidesPerView: 1.8,
      spaceBetween: 14,
    },
    // when window width is >= 576px
    576: {
      slidesPerView: 2.2,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.4,
    },
    // when window width is >= 993px
    993: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
  },
});

// testiomonial slider js start--
var swiper = new Swiper(".testimonial-slider", {
  slidesPerView: 2.7,
  // spaceBetween: 24,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".testimonial-slider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".testimonial-slider-btn-next",
    prevEl: ".testimonial-slider-btn-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      slidesPerView: 1.3,
      // spaceBetween: 20,
    },
    // when window width is >= 576px
    576: {
      slidesPerView: 2,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.3,
    },
    // when window width is >= 993px
    993: {
      slidesPerView: 2.7,
    },
  },
});
// testiomonial slider js end--
// Initialize the main product swiper

var swiper = new Swiper(".product-swiper", {
  loop: false, // Set to false as we're handling small numbers of thumbnails
  spaceBetween: 15,
  slidesPerView: 5, // Show 5 thumbnails by default
  grabCursor: true,
  breakpoints: {
    320: {
      slidesPerView: 1.15, // Adjust for smaller screens
    },
    576: {
      slidesPerView: 2, // Show 2 thumbnails on medium screens
    },
    768: {
      slidesPerView: 3, // Show 3 thumbnails on larger screens
    },
    993: {
      slidesPerView: 4, // Show 4 thumbnails on very large screens
    },
  },
});

var swiper2 = new Swiper(".product-swiper-2", {
  loop: true,
  slidesPerView: 1,
  grabCursor: true,
  spaceBetween: 0,
  pagination: {
    el: ".product-swiper2-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".product-swiper2-btn-next",
    prevEl: ".product-swiper2-btn-prev",
  },
  thumbs: {
    swiper: swiper, // Link thumb swiper to the main image swiper
  },
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    576: {
      slidesPerView: 1.15,
    },
    768: {
      slidesPerView: 1,
    },
    993: {
      slidesPerView: 1,
    },
  },
});

// Ensure swiper updates dynamically if less than 5 thumbnails
// var thumbSlidesCount = $(".product-swiper .swiper-slide").length; // Get the number of thumbnail slides
// console.log('Number of thumbnail slides:', thumbSlidesCount);

// if (thumbSlidesCount < 5) {
//     swiper.params.slidesPerView = thumbSlidesCount;  // Adjust the number of thumbnails based on the available slides
//     swiper.update();  // Re-initialize swiper with updated settings
// }

// **..product-single-slider js end..**

// modal js start---
// var modal = document.querySelector(".modal");
// var measurement_guide_modal_btn = document.querySelector(".measurement-guide-modal-btn");
// var closeButton = document.querySelector(".close-button");

// function toggleModal() {
//     modal.classList.toggle("show-modal");
// }

// function windowOnClick(event) {
//     if (event.target === modal) {
//         toggleModal();
//     }
// }

// measurement_guide_modal_btn.addEventListener("click", toggleModal);
// closeButton.addEventListener("click", toggleModal);
// window.addEventListener("click", windowOnClick);
// modal js end---

$(document).ready(function () {
  // if variation is select value
  $(".single_selector").on("change", function () {
    let variantName = "";
    $(".single_selector").each(function (e) {
      variantName += e != 0 ? "-" : "";
      variantName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == variantName) {
        $(this).parent().val($(this).val());
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");

        $(".main_qty").attr("data-price", price);

        $("#product_id").val(id);
        if (available == true) {
          $(".addToCart").removeClass("sold_out").text("👉 Add to Basket");
        } else {
          $(".addToCart").addClass("sold_out").text("Sold Out");
        }

        updateTotalPrice(); // Ensure recalculation happens after price update
      }
    });
  });

  // add to cart

  $(".addToCart").on("click", function (e) {
    e.preventDefault();

    var items = [];
    var mainProductProperties = {};

    // Get main product properties
    $(".product-properties").each(function () {
      var propertyKey = $(this).data("property-key");
      var propertyValue = $(this).val();
      if (propertyKey && propertyValue) {
        mainProductProperties[propertyKey] = propertyValue;
      }
    });

    var mainProductId = $("#product_id").val();
    var mainQuantity = $(".main_qty").val();

    // Add main product to items
    if (mainQuantity > 0) {
      items.push({
        id: mainProductId,
        quantity: mainQuantity,
        properties: mainProductProperties,
      });
    }

    // Add extra products to items
    $(".extra_product").each(function () {
      var productId = $(this).val();
      var quantity = parseInt($(this).data("qty"));

      if (quantity > 0) {
        items.push({
          id: productId,
          quantity: quantity,
          // properties: {
          // 	main_product_id: mainProductId  // Link to main product
          // }
        });
      }
    });

    // Send the AJAX request to add items to the cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function (response) {
        // alert('Item(s) added to cart successfully!');
        $(".cart-sidebar").addClass("active");
        updateCartCount();
        cart_item_update();
      },
      error: function (err) {
        console.error("Error:", err);
        alert("Failed to add item(s) to the cart. Please try again.");
      },
    });
  });

  // Call this function when you remove the main product
  $(".cart-item-remove").on("click", function (e) {
    var itemId = $(this).data("id");
    var mainProductId = $(this).data("main-product-id"); // Assume you've set this on the remove button
    removeMainAndExtras(mainProductId);
  });

  // Update cart count function
  function updateCartCount() {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        const itemCount = cart.item_count; // Total items in the cart
        $(".shopping-count").text(itemCount); // Update the cart count in the header
      },
      error: function (err) {
        console.error("Error fetching cart:", err);
      },
    });
  }

  // price calculator
  updateTotalPrice();

  $(".quantity-increase").on("click", function () {
    const $button = $(this);
    const $input = $button.siblings(".quantity-total");
    let currentQuantity = parseInt($input.val(), 10) || 0;

    let properties = $input.data("properties");

    // Increase quantity
    let qty = currentQuantity + 1;
    let id = $input.data("id");
    $input.val(qty);
    $(this)
      .parent()
      .parent()
      .find(".extra_product, .product_price")
      .val(id)
      .prop("disabled", false);
    $(this).parent().parent().find(".extra_product").attr("data-qty", qty);

    $("#" + properties).val(qty);

    // Update total price
    updateTotalPrice();
  });

  $(".quantity-decrease").on("click", function () {
    const $button = $(this);
    const $input = $button.siblings(".quantity-total");
    let currentQuantity = parseInt($input.val(), 10) || 0;
    let id = $input.data("id");
    let properties = $input.data("properties");

    // Decrease quantity (but not below 0)
    if (currentQuantity > 0) {
      let qty = currentQuantity - 1;

      $input.val(qty);
      if (qty == 0) {
        $(this)
          .parent()
          .parent()
          .find(".extra_product, .product_price")
          .prop("disabled", true);
      } else {
        $(this)
          .parent()
          .parent()
          .find(".extra_product, .product_price")
          .prop("disabled", false);
      }
      $(this).parent().parent().find(".extra_product").attr("data-qty", qty);

      $("#" + properties).val(qty);
    }

    // Update total price
    updateTotalPrice();
  });

  // main product quantity
  $(".qty_plus").on("click", function () {
    const $button = $(this);
    const $input = $button.siblings(".quantity-total");
    let currentQuantity = parseInt($input.val(), 10) || 0;

    // Increase quantity
    let qty = currentQuantity + 1;
    $input.val(qty);

    // Update total price
    updateTotalPrice();
  });

  $(".qty_minus").on("click", function () {
    const $button = $(this);
    const $input = $button.siblings(".quantity-total");
    let currentQuantity = parseInt($input.val(), 10) || 0;

    // Decrease quantity (but not below 0)
    if (currentQuantity > 1) {
      let qty = currentQuantity - 1;
      $input.val(qty);
    }

    // Update total price
    updateTotalPrice();
  });

  $(".select_extra").on("change", function () {
    // Update total price when dropdown changes
    let properties = $(this).data("properties");
    let qty = $(this).val();
    if (qty == 0) {
      $(this)
        .parent()
        .parent()
        .find(".extra_product, .product_price")
        .prop("disabled", true);
      $("#" + properties).val("No");
    } else {
      $(this)
        .parent()
        .parent()
        .find(".extra_product, .product_price")
        .prop("disabled", false);
      $("#" + properties).val("Yes");
    }
    $(this).parent().parent().find(".extra_product").attr("data-qty", qty);
    updateTotalPrice();
  });



  $(".cart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    const overlay = document.querySelector('.overlayussge');
    $(".cart-sidebar").removeClass("active");
    $("body").removeClass("active");
    if (overlay) overlay.style.display = 'none';
  });

  $(".cart-close-btn").click(function (event) {
    event.stopPropagation();
    const overlay = document.querySelector('.overlayussge');
    $(".cart-sidebar").toggleClass("active");
    $("body").toggleClass("active");
    if (overlay) overlay.style.display = 'none';
  });

  cart_content_show();

  // produdct option select

  // if variation is radio value
  $(".option_input").on("change", function () {
    let optionName = "";
    $("input:radio.option_input:checked").each(function (e) {
      optionName += e != 0 ? "-" : "";
      optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == optionName) {
        $(this).parent().val($(this).val());
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");

        $("#product_id").val(id);
        if (available == true) {
          $(".product-btn").removeClass("sold_out").text("Add to my bag");
        } else {
          $(".product-btn").addClass("sold_out").text("Sold Out");
        }
      }
    });
  });

  $(".shape-dimension-tabs-nav-link").click(function () {
    $(".shape-dimension-tab-nav").removeClass("active");
    $(this).parent().addClass("active");
    $(".shape-dimension-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  $(".product-color-varient-tab-link").click(function (e) {
    e.preventDefault();
    $(this).parent().addClass("active").siblings().removeClass("active");
    var id = $(this).data("id");
    $("#item_" + id)
      .fadeIn()
      .siblings()
      .fadeOut();
    let select_text = $("#item_" + id)
      .find(".color_select:checked")
      .val();
    $(".selected_color").text(select_text);
  });
});

function updateTotalPrice() {
  let total = 0;

  const mainProductQuantity = parseInt($(".main_qty").val()) || 0;
  let mainProductPrice = parseFloat($(".main_qty").attr("data-price")) || 0;
  mainProductPrice = mainProductPrice * 0.01;

  total += mainProductQuantity * mainProductPrice;

  // Iterate over each quantity input with class .extra_qty
  $(".extra_qty").each(function () {
    const quantity = parseInt($(this).val()) || 0; // Get the quantity, default to 0 if invalid
    let price = parseFloat($(this).data("price")) || 0; // Get the price from data-price attribute
    price = price * 0.01; // Get the price from data-price attribute

    // Only add to total if the quantity is greater than 0
    if (quantity > 0) {
      total += quantity * price; // Add price * quantity to the total
    }
  });

  $(".select_extra").each(function () {
    const selectValue = $(this).val(); // Get the selected value (0 or 1)
    let price = parseFloat($(this).data("price")) || 0; // Get the price from data-price attribute
    price = price * 0.01; // Get the price from data-price attribute

    // Only add to total if "Yes" is selected
    if (selectValue == "1") {
      total += price; // Add the price if the select option is "Yes"
    }
  });

  // Update the total price display
  $("#total_price").text(currency + total.toFixed(2)); // Display total price
}

function cart_item_update() {
  fetch("/?section_id=cart-drawer")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_top = $(".cart-top-wrap", cart_html);
      var cart_items = $(".cart-drawer-items", cart_html);
      var cart_footer = $(".cart-footer-wrap", cart_html);
      $(".cart-top-wrap").replaceWith(cart_top);
      $(".cart-drawer-items").replaceWith(cart_items);
      $(".cart-footer-wrap").replaceWith(cart_footer);
    });

  cart_content_show();
}

function cart_content_show() {
  $.getJSON("/cart.js", function (cart) {
    var total_items = cart.item_count; // Assign inside the callback
    if (total_items == 0) {
      $(".empty-cart-content-area").show();
      $(".cart-footer").hide();
    } else {
      $(".empty-cart-content-area").hide();
      $(".cart-footer").show();
    }
    $(".cart-item-number, .shopping-count").text(total_items);
  });
}

// search result

function search_result_show() {
  if (query.length < 3) {
    resultsContainer.innerHTML = "";
    $(".search-results-wrap").hide();
    return;
  } else {
    $(".search-results-wrap").show();
  }
}

// header search
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("header_search");
  const resultsContainer = document.getElementById("search_results");

  const searchPageInput = document.getElementById("search_page_input");
  const resultsPageContainer = document.getElementById("main_search_results");

  // $('.search-results-wrap').hide();

  // header search input
  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();

    if (query.length < 3) {
      resultsContainer.innerHTML = "";
      $(".search-results-wrap").hide();
      return;
    } else {
      $(".search-results-wrap").show();
    }
    document
      .querySelector(".search-bar-close-icon")
      .addEventListener("click", function () {
        resultsContainer.innerHTML = "";
        return;
      });

    // Perform an AJAX request to the Shopify search endpoint
    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query
      )}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,body`
    )
      .then((response) => response.json())
      .then((data) => {
        const products = data.resources.results.products;

        if (products.length) {
          const productsHtml = products
            .map(
              (product) => `
            <div class="search-result-item">
              <a href="${product.url}">
                <img class="search-product-img" src="${product.image}" alt="${product.title}" />
                <div class="search-product-content">
                  <h3 class="search-product-heading">${product.title}</h3>
                  <p class="search-product-price">From ${currency}${product.price}</p>
                </div>
              </a>
            </div>
          `
            )
            .join("");

          resultsContainer.innerHTML = `
            ${productsHtml}
            <div class="more-results-search">
              <a href="/search?q=${encodeURIComponent(query)}">More Results →</a>
            </div>
          `;
        } else {
          resultsContainer.innerHTML = `<div><p>No results found.</p></div>`;
        }
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
      });
  });

  // search page
  searchPageInput.addEventListener("input", function () {
    const query = searchPageInput.value.trim();

    if (query.length < 3) {
      resultsPageContainer.innerHTML = "";
      $(".main-results-wrap").hide();
      return;
    } else {
      $(".main-results-wrap").show();
    }

    document
      .querySelector(".search-bar-close-icon")
      .addEventListener("click", function () {
        resultsPageContainer.innerHTML = "";
        return;
      });

    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query
      )}&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,body`
    )
      .then((response) => response.json())
      .then((data) => {
        const products = data.resources.results.products;

        if (products.length) {
          // build product list HTML
          const productsHtml = products
            .map(
              (product) => `
                <div class="search-result-item">
                  <a href="${product.url}">
                    <img class="search-product-img" src="${product.image}" alt="${product.title}" />
                    <div class="search-product-content">
                      <h3 class="search-product-heading">${product.title}</h3>
                      <p class="search-product-price">From ${currency}${product.price}</p>
                    </div>
                  </a>
                </div>
              `
            )
            .join("");

          // add "More results" link under products
          resultsPageContainer.innerHTML = `
            ${productsHtml}
            <div class="more-results-search">
              <a href="/search?q=${encodeURIComponent(query)}">More Results →</a>
            </div>
          `;
        } else {
          resultsPageContainer.innerHTML = `<div><p>No results found.</p></div>`;
        }
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
      });
  });
});

//   custom image

const dropArea = document.querySelector(".custom-image-wrap"),
  button = dropArea.querySelector(".custom-image-btn"),
  dragText = dropArea.querySelector("header"),
  input = dropArea.querySelector("#custom_image_input");
let file;
var filename;

button.onclick = () => {
  input.click();
};

input.addEventListener("change", function (e) {
  var fileName = e.target.files[0].name;
  let filedata = `
  	<div class="custom-image-content">
		<h4>${fileName}</h4>
	</div>
	<button class="btn-secondary custom-image-btn">Upload</button>`;
  dropArea.innerHTML = filedata;
});
